export default function useUnsavedChanges() {
  function acceptUnsavedChanges() {
    return confirm("You have unsaved changes on screen. Do you want to leave this screen and discard your changes?");
  }

  return {
    acceptUnsavedChanges,
  };
}
